import _extends from "@babel/runtime/helpers/esm/extends";
import { get, omit } from 'lodash';
const removePropFromComponent = (child, ...propsToRemove) => {
  const childProps = get(child, 'props');
  const propsToBeUsed = omit(childProps, propsToRemove);
  const childWithoutProps = omit(child, ['props']);
  const childWithNewProps = _extends({}, childWithoutProps, {
    props: propsToBeUsed
  });
  return childWithNewProps;
};
export default removePropFromComponent;